import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { useLoading } from '../../context/useLoading'
import WithMainLayout from '../../hocs/withMainLayout'
import Loading from '../shared/Loading'
import { axiosKazlingoFormData } from '../../utils/axiosKazlingo'
import Streaks from './QShop'
import { errorLog } from '../../utils/errorLog'

const processData = (formData, values) => {
  console.log('values >>> ', values)

  const file = values.imageFile.originFileObj
  const previewImageFile = values.previewImage.originFileObj

  formData.append('icon', file, file.name)
  formData.append('category', values.category)
  formData.append('name', values.name)
  formData.append('price', values.price)
  formData.append('iconPreview', previewImageFile, previewImageFile.name)
}

const QShopContainer = () => {
  const { showLoading, hideLoading } = useLoading()
  const [allGoods, setAllGoods] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchGoods = async () => {
      try {
        const { data } = await axiosKazlingoFormData.get('/q-shop/goods')
        setAllGoods(data.data)
      } catch (error) {
        setError(error)
        toast.error('Ошибка при загрузке')
      } finally {
        setLoading(false)
      }
    }
    fetchGoods()
  }, [])

  const addGoodsHandler = async (form, closeFunc) => {
    try {
      console.log('form', form)
      const values = await form.validateFields()
      form.resetFields()
      showLoading()
      const formData = new FormData()

      processData(formData, values)

      const response = await axiosKazlingoFormData.post(
        '/q-shop/goods',
        formData
      )
      if (response.status == 201) {
        setAllGoods([...allGoods, response.data])
        toast.success('Успешно добавлено')
      }
    } catch (error) {
      errorLog(error)
    } finally {
      hideLoading()
      closeFunc(false)
    }
  }

  const updateGoodsHandler = async (_id, form, closeFunc) => {
    try {
      const values = await form.validateFields()
      form.resetFields()
      showLoading()
      const formData = new FormData()
      Object.keys(values).forEach(key => {
        formData.append(key, values[key])
      })
      const response = await axiosKazlingoFormData.put(
        `/q-shop/goods/details/${_id}`,
        formData
      )
      setAllGoods(allGoods.map(a => (a._id === _id ? response.data : a)))
      toast.success('Good обновлен')
    } catch (error) {
      console.error('Ошибка при обновлении good:', error)
      const errorMessage =
        error.response && error.response.data.errors
          ? error.response.data.errors[0].error_message
          : 'Ошибка при добавлении'
      toast.error(errorMessage)
    } finally {
      hideLoading()
      closeFunc(false)
    }
  }

  const deleteGoodsHandler = async (_id, closeFunc) => {
    try {
      showLoading()
      await axiosKazlingoFormData.delete(`/q-shop/goods/details/${_id}`)
      setAllGoods(allGoods.filter(a => a._id !== _id))
      toast.success('Успешно удалено')
    } catch (error) {
      errorLog(error)
    } finally {
      hideLoading()
      closeFunc(false)
    }
  }

  if (loading) {
    return <Loading />
  }

  if (error) {
    return <div>Ошибка при загрузке</div>
  }

  return (
    <Streaks
      goods={allGoods}
      updateHandler={updateGoodsHandler}
      createHandler={addGoodsHandler}
      deleteHandler={deleteGoodsHandler}
    />
  )
}

export default WithMainLayout(QShopContainer)
